import util from '@bmp-vue/core/api/util'

let controller = 'parceiros'
export default Object.assign({}, util.GetCrud(controller, null), {
    GetParceiroParametrizacao: function (codigoParceiro) {
        return util.Axios.Get(controller + '/parametrizacao', codigoParceiro);
    }
})

